import { ArrowBack as IconArrowBack } from "@mui/icons-material";
import { IconButton, Skeleton, Stack, Typography } from "@mui/material";
import { Link, To } from "react-router";

import { MapPanel, MapPanelHeader, MapPanelScrollableArea } from "~/modules/map/components/MapPanel";

export function PlannerV2AreaDetailSkeleton({ backHref }: { backHref: To }) {
    return (
        <MapPanel>
            <MapPanelHeader>
                <IconButton component={Link} color="inherit" to={backHref}>
                    <IconArrowBack />
                </IconButton>

                <Stack>
                    <Skeleton variant="text" width={200} height={20} />
                    <Skeleton variant="text" width={150} height={32} />
                </Stack>
            </MapPanelHeader>
            <MapPanelScrollableArea>
                <Stack>
                    <Typography
                        variant="overline"
                        sx={theme => ({
                            position: "sticky",
                            top: 0,
                            backgroundColor: theme.palette.background.paper,
                            paddingInline: 2,
                            paddingBlock: 1,
                            borderBottom: `1px solid ${theme.palette.divider}`,
                        })}
                    >
                        <Skeleton variant="text" width={100} />
                    </Typography>
                    {[1, 2].map(visitIndex => (
                        <Stack
                            key={visitIndex}
                            paddingInline={2}
                            paddingBlock={2}
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            gap={2}
                            sx={theme => ({
                                borderBottom: `1px solid ${theme.palette.divider}`,
                            })}
                        >
                            <Stack padding={1} flexGrow={1} rowGap={1}>
                                <Stack direction="row" columnGap={2} alignItems="center">
                                    <Skeleton variant="circular" width={24} height={24} />
                                    <Stack flexGrow={1}>
                                        <Skeleton variant="text" width={180} height={24} />
                                        <Skeleton variant="text" width={120} height={20} />
                                    </Stack>
                                </Stack>
                                <Skeleton variant="rectangular" width="100%" height={24} />
                            </Stack>
                            <Skeleton variant="circular" width={24} height={24} />
                        </Stack>
                    ))}
                </Stack>
            </MapPanelScrollableArea>
        </MapPanel>
    );
}
